import { Component, OnInit,  Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { InstalacionService } from 'src/app/services/instalacion.service';
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ClienteService } from 'src/app/services/cliente.service';
import {MatCheckboxModule} from '@angular/material/checkbox';

//ROUTE
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login.service';
import { GrupoService } from 'src/app/services/grupo.service';
import {PROVINCIAS} from './../../../../../constants/constants';


@Component({
  selector: 'app-nueva-instalacion-cliente',
  templateUrl: './nueva-instalacion-cliente.component.html',
  styleUrls: ['./nueva-instalacion-cliente.component.scss']
})
export class NuevaInstalacionClienteComponent implements OnInit {

  //rutas
  public id?: any;
  public params?: any

  isLinear = false;
  datosInstalacion: any={};
  public instalaciones: any[] = [];
  public IDinstalaciones: any[] = [];
  public contratistas: any[] = [];
  public IDcontratistas: any[] = [];
  public nombreContratistas: any[] = [];
  public zonas: any
  public idZonas: any
  public zonasSeleccionado: any[]= [];
  grupos:any
  userLog:any
  campos:any =[]
  grupoSeleccionado:any =[]
  nombreGrupo:any
  allCampos:any = []
  camposId:any = []
  provincias:any
  autonomia:any
  provincia:any

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private apollo: Apollo,
    private instalacionService: InstalacionService,
    private clienteService: ClienteService, public dialog: MatDialog,
    private route: ActivatedRoute, private loginService:LoginService,
    private grupoService: GrupoService) {
      /* this.route.params?.subscribe( params => console.log(params)); */
    /* this.buildForm(); */
    this.userLog = this.loginService.getUserData()
    this.provincias = PROVINCIAS
    }

  ngOnInit() {
    this.buildForm();
    this.getInstalacionesByCliente()
    this.getContratistasByCliente()
    this.getZonasByCliente()
    this.getGruposByCliente()
  }

  private buildForm(){
    this.datosInstalacion = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      via: ['', [Validators.required]],
      nombreVia: ['', [Validators.required]],
      numero: ['', [Validators.required]],
      pta: [''],
      letra: [''],
      cp: ['', [Validators.required]],
      provincia: ['', [Validators.required]],
      ccaa: ['', [Validators.required]],
      zonas: ['', [Validators.required]],
      grupos: [''],
      contratista:[''],
    });
    }

    selectProvincia(e:any){
      if (e) {
        this.autonomia = e.value.COMUNIDAD_AUTONOMA;
        this.provincia = e.value.NOMBRE;
      }
      
    }

    selectAllZonas(e:any){
      if (e) {
        const allZonas = this.zonas;
        allZonas.forEach((zona:any) => {
          this.zonasSeleccionado.push(zona.id)
        });   
      }else{
        this.zonasSeleccionado = [];
      }
    }
  
    selectZona(e:any){
  
      const zona = e.value;
      if (e.selected) {
        this.zonasSeleccionado?.push(zona)
        console.log(this.zonasSeleccionado)
      }else{
        this.zonasSeleccionado = this.zonasSeleccionado?.filter((i:any)=> i !== zona) 
        console.log(this.zonasSeleccionado)
      }
    }

  getInstalacionesByCliente(): void {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getInstalacionesByCliente(),
      variables: {
        "id": this.userLog.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        
        this.instalaciones = data.cliente.instalaciones
        this.instalaciones.forEach(instalacion => {
       
        this.IDinstalaciones.push(instalacion.id)
        })

      }
      )
  }

   getContratistasByCliente(): void {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getContratistasByCliente(),
      variables: {
        "id": this.userLog.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data.cliente.contratistas)
        this.contratistas = data.cliente.contratistas

       /*  this.contratistas.forEach(contratista => 
        this.IDcontratistas.push(contratista.id));

        this.contratistas.forEach(contratista =>
        this.nombreContratistas.push(contratista.nombreComercial));

        console.log(this.IDcontratistas)
        console.log(this.nombreContratistas) */

      }
      )
  }

  getZonasByCliente(){
    this.apollo.watchQuery<any>({
      query: this.clienteService.getZonasByCliente(),
      variables: {
        "id": this.userLog.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.zonas = data.cliente.zonas
        this.zonas?.forEach((instalacion:any) => {
          this.idZonas?.push(instalacion.id)
        });
      }
      )
  }

  getGruposByCliente() {
    this.apollo.watchQuery<any>({
      query: this.grupoService.getGruposByCliente(),
      variables: {
        "id": this.userLog.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
     
        this.grupos = data.cliente.agrupacions
   
      });
    
  }


  addInstalacion(): void {
    const grupos = [...new Set(this.grupoSeleccionado)];
    this.apollo.mutate<any>({
      mutation: this.instalacionService.addInstalacion(),
      variables: {
        "input": {
          "data": {
            "nombre": this.datosInstalacion.value.nombre,
            "cliente": this.userLog.cliente.id,
            "direccion": {
              "tipoVia": this.datosInstalacion.value.via,
              "nombre": this.datosInstalacion.value.nombreVia,
              "pta": this.datosInstalacion.value.pta,
              "numero": this.datosInstalacion.value.numero,
              "letra": this.datosInstalacion.value.letra,
              "codigoPostal": this.datosInstalacion.value.cp,
              "provincia": this.provincia,
              "ccaa": this.datosInstalacion.value.ccaa,
              
            },
            "contratistas": this.datosInstalacion.value.contratista,
            "zonas": this.zonasSeleccionado,
            "agrupacions": grupos,
            "campos": this.camposId
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('CREADO', data)
      this.IDinstalaciones.push(data.createInstalacion.instalacion.id)
      this.updateClienteById()
      setTimeout(() => {
        location.reload()
      }, 800);
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

async save(event:Event){
    event.preventDefault();
    this.addInstalacion();
    await this.updateClienteById();
  }
  updateClienteById(){
    this.apollo.mutate({
      mutation: this.clienteService.updateCliente(),
      variables: {
        "input": {
          "where": {
            "id": this.userLog.cliente.id
          },
          "data": {
            "instalaciones": this.IDinstalaciones
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }


selectGrupo(e:any){

    this.getCamposByGrupo(e.value)
  
  

}

selectAllGrupos(e:any){

}

getCamposByGrupo(id:any){
  this.apollo.watchQuery<any>({
    query: this.grupoService.getCamposByGrupo(),
    variables: {
      "id": id
    }
  })
    .valueChanges
    .subscribe(({ data, loading, errors }) => {
      this.nombreGrupo = data.agrupacion.nombre
      this.campos = data.agrupacion.campos
    });
}

selectCampo(e:any){
  const campo = e.value;
      if (e.selected) {
        this.allCampos?.push(campo)
       this.grupoSeleccionado.push(campo.agrupacion.id)
        
        this.camposId.push(campo.id)
        console.log(this.grupoSeleccionado);
        
      }else{
        this.allCampos = this.allCampos?.filter((i:any)=> i !== campo) 
        this.camposId = this.camposId?.filter((i:any)=> i !== campo.id) 
        this.grupoSeleccionado = this.grupoSeleccionado?.filter((i:any)=> i !== campo.agrupacion.id) 
        console.log(this.allCampos)
        console.log(this.grupoSeleccionado);
        
      }
}
 

}
